<template>
  <div>
    <span
      class="icon-loadingInDialog"
      v-show="isShowLoadingIcon"
      :class="[iconStyle==='top'?'loading-top':'loading-bottom']"
    >
      <div class="circle1"></div>
      <div class="circle2"></div>
      <span class="text">正在加载数据...</span>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["isShowLoadingIcon", "iconStyle"]
};
</script>

<style lang="less" scoped>
@circle_left: 37%;
.loading-top {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
}
.loading-bottom{
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
}
.icon-loadingInDialog {
  z-index: 99999;
  width: 100%;
  height: 35px;
  line-height: 22px;
  background-color: #fff;
  text-align: right;
  padding-right: 12px;
  text-align: center;
  cursor: not-allowed;
  .circle1 {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #415af6;
    position: absolute;
    top: 50%;
    left: @circle_left;
    margin-left: -7.5px;
    margin-top: -7.5px;
    opacity: 0.4;
    animation: bounce 2s infinite ease-in-out;
  }
  .circle2 {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #415af6;
    position: absolute;
    top: 50%;
    left: @circle_left;
    margin-left: -7.5px;
    margin-top: -7.5px;
    opacity: 0.6;
    animation: bounce 2s infinite ease-in-out;
    animation-delay: -1s;
  }
  .text {
    line-height: 35px;
    font-weight: bold;
  }
  @keyframes bounce {
    0%,
    100% {
      transform: scale(0);
    }
    50% {
      transform: scale(1);
    }
  }
}
</style>
